import type { ComponentType } from "react";
import { RoleName } from "consts/auth";
import useUser from "features/auth/useUser";
import useOnboardingBootstrap from "features/ecommerce/useOnboardingBootstrap";
import type { DashboardProps } from "./types";

export const withBoostrap = <TProps extends object>(
    Component: ComponentType<TProps>,
    bootstrapStrategy: Map<RoleName, DashboardProps['useBootstrap']> = new Map([
        [RoleName.OnboardingE, useOnboardingBootstrap],
        [RoleName.OnboardingO, useOnboardingBootstrap]
    ])
) =>
    (props: TProps) => {
        const { getRoleName } = useUser();

        return (
            <Component
                {...props}
                useBootstrap={bootstrapStrategy.get(getRoleName())}
            />
        );
    };

export default withBoostrap;